import { render, staticRenderFns } from "./noFondPage.vue?vue&type=template&id=1a7a71bc&scoped=true&"
import script from "./noFondPage.vue?vue&type=script&lang=ts&"
export * from "./noFondPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7a71bc",
  null
  
)

export default component.exports